import { useState, useRef } from 'react';
import {stateNames as toastDownloadStateNames} from "../components/common/Toast";

const downloadFileRequest = async (evaluationId) => {
    let url = `https://services-375925469890.us-central1.run.app/download/pdf/${evaluationId}`;
    return fetch(url, {method: 'GET'});
}

const usePdfDownload = () => {
    const pdfBlobRef = useRef(null);
    const downloadPdfTimeout = useRef(null);
    const [downloadPdfState, setPdfState] = useState(null);

    const setDownloadPdfState = (state) => {
        setPdfState(state);

        downloadPdfTimeout.current && clearTimeout(downloadPdfTimeout.current);
        if(state === toastDownloadStateNames.success || state === toastDownloadStateNames.error) {
            downloadPdfTimeout.current = setTimeout(() => setPdfState(null), 10000);
        }
    }

    const onHandleDownloadEvaluatedFile = async (evaluationId) => {
        setDownloadPdfState(toastDownloadStateNames.isLoading);
        await downloadFileRequest(evaluationId)
            .then(response => response.blob())
            .then(blobFile => {
                setDownloadPdfState(toastDownloadStateNames.success);
                pdfBlobRef.current = blobFile;
                downloadEvaluatedFile(blobFile, evaluationId);
            })
            .catch(err => {
                setDownloadPdfState(toastDownloadStateNames.error);
                console.log(err);
            });
    }

    const downloadEvaluatedFile = async (blobFile, evaluationId) => {
        try {
            const element = document.createElement('a');
            element.href = URL.createObjectURL(blobFile);
            element.download = evaluationId;
            document.body.appendChild(element);
            element.click();
            URL.revokeObjectURL(element.href);

            setDownloadPdfState(null);
        } catch (e) {
            console.log(e);
        }
    }

    return {
        downloadEvaluatedFile,
        onHandleDownloadEvaluatedFile,
        downloadPdfState,
        pdfBlob: pdfBlobRef.current
    };
};

export default usePdfDownload;